import React from 'react';
import { Link } from 'react-router-dom';
import { PageSettings } from './../../config/page-settings.js';

import Auth from '../../services/auth';
import UserProfile from '../../services/userProfile';

const auth = new Auth();
const userProfile = new UserProfile();

class SidebarProfile extends React.Component {

	constructor(props) {
		super(props);
		const profile = userProfile.getUserProfile();
		this.state = {
			profileActive: 0,
			username: (profile) ? profile.username : '',
			fullname: (profile) ? profile.fullname : '',
			roleName: (profile) ? profile.roleName : '',
			photoProfile: (profile) ? profile.photoProfile : '',
			branch: (profile) ? profile.branch : '',
			branchName: (profile) ? profile.branchName : '',
		};
		this.handleProfileExpand = this.handleProfileExpand.bind(this);
	}

	handleProfileExpand(e) {
		e.preventDefault();
		this.setState(state => ({
			profileActive: !this.state.profileActive,
		}));
	}
  
	render() {
		const { fullname, roleName, photoProfile, branchName } = this.state;
		return (
			<PageSettings.Consumer>
				{({pageSidebarMinify}) => (
					<ul className="nav">
						<li className={"nav-profile " + (this.state.profileActive ? "expand " : "")}>
							<Link to="/" onClick={this.handleProfileExpand}>
								<div className="cover with-shadow"></div>
								<div className="image image-icon bg-black text-grey-darker">
									{/* <i className="fa fa-user"></i> */}
									<img src={photoProfile} alt="photoprofile" className="img-responsive"/>
								</div>
								<div className="info">
									<b className="caret pull-right"></b>
									{fullname}
									<small>{roleName}</small>
									<small>{branchName}</small>
								</div>
							</Link>
						</li>
						<li>
							<ul className={"nav nav-profile " + (this.state.profileActive && !pageSidebarMinify ? "d-block " : "")}>
								<li><Link to="/user/profile"><i className="fa fa-user"></i> Profile</Link></li>
								<li><a href={'/#'} onClick={() => auth.logout()}><i className="fas fa-sign-out-alt"></i> <span>Logout </span></a></li>
							</ul>
						</li>
					</ul>
				)}
			</PageSettings.Consumer>
		)
	}
}

export default SidebarProfile;